import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cac0a236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RegistrationHeader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "Title" }, [
  /*#__PURE__*/_createTextVNode(" Create a "),
  /*#__PURE__*/_createElementVNode("span", { class: "TitleHighlight" }, " free account "),
  /*#__PURE__*/_createTextVNode(" to get scholarship updates ")
], -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SubText" }, " Receive personalised scholarship recommendations and reminders before application deadlines ", -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
}